// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__2-whx","footer":"ModalCreateQualiphyProcedure_footer__2V8U2","additionData":"ModalCreateQualiphyProcedure_additionData__2eRxW"};